import React from "react";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

/* etiqueta/valor: "Comprador" para el organizador, "Evento" para quien compró */
const BarraCompra = ({ compraId, etiqueta, valor, onVolver, children }) => (
  <div
    className="d-flex justify-content-between align-items-center flex-wrap gap-2"
    style={{ backgroundColor: "white", borderBottom: "1px solid #E4E4E7", padding: 10, marginBottom: 20 }}
  >
    <div className="d-flex align-items-center flex-wrap gap-3">
      <IconButton onClick={onVolver} aria-label="Volver" size="small">
        <ArrowBack />
      </IconButton>
      <p className="mb-0" style={{ fontWeight: 600 }}>Compra #{compraId}</p>
      <span style={{ borderRight: "1px solid #e4e4e7", alignSelf: "stretch" }} />
      <p className="mb-0">{etiqueta}: <span style={{ fontWeight: 600 }}>{valor}</span></p>
    </div>
    {children}
  </div>
);

export default BarraCompra;
